
import React, {useEffect, useState, Fragment} from 'react';
import { useMutation } from "react-query";
import apiClient from "../../http-common";
import {
    triggerSuccess,
    triggerError,
    setErrorMessage,
    setSuccessMessage,
  } from '../Request/StatusFormatter';

const ManageFunding = () => {

    const [funding, setFunding] = useState('');   
    const getAmount = (amount)=> new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', currencySign: 'accounting' }).format(amount);
    const getDate = (date) => new Date(date).toDateString();

    const { isLoading: isApprovingfunding, mutate: approvefunding } = useMutation(        
        async () => {
          return await apiClient.post(`/api/admin-approve-funding/${funding.id}`);
        },
        {
          onSuccess: (res) => {
            setSuccessMessage(res.data);
            triggerSuccess(); 
            
          },
          onError: (err) => {
            setErrorMessage(err.response?.data || err);         
            triggerError();
          },
        }
      );

    const { isLoading: isDceliningfunding, mutate: declinefunding } = useMutation(        
        async () => {
          return await apiClient.post(`/api/decline-funding/${funding.id}`);
        },
        {
          onSuccess: (res) => {
            setSuccessMessage(res.data);
            triggerSuccess(); 
            
          },
          onError: (err) => {
            setErrorMessage(err.response?.data || err);         
            triggerError();
          },
        }
      );
    
    useEffect(() => {
        window.addEventListener('adminhistoryfundingSelected', function (e) {
            let selectedfunding = localStorage.getItem('adminhistoryfundingSelected');
            if (selectedfunding != null) {
                selectedfunding = JSON.parse(selectedfunding); 
                setFunding(selectedfunding);
            }
        }, false);
    })
  return (
    <div>
        <div id="admin-funding-history-menu" className="offcanvas offcanvas-bottom offcanvas-attached">
            <div className="menu-size" style={{height:"520px"}}>
                {funding !== '' &&
                <div className="content">
                <a href="/#" className="d-flex py-1 pb-4">
                    <div className="align-self-center">
                        <span className="icon rounded-s me-2 gradient-green shadow-bg shadow-bg-xs"><i className="bi bi-person-circle font-18 color-white"></i></span>
                    </div>
                    <div className="align-self-center ps-1">
                        <h5 className="pt-1 mb-n1">{funding.user.email}</h5>
                        <p className="mb-0 font-11 opacity-70">{getAmount(funding.amount)}</p>
                    </div>
                    <div className="align-self-center ms-auto text-end">
                    {funding.status === 'pending' && <h4 className="pt-1 font-14 mb-n1 color-yellow-dark">{funding.status}</h4>}
                    {funding.status === 'waiting approval' && <h4 className="pt-1 font-14 mb-n1 color-yellow-dark">{funding.status}</h4>}
                    {funding.status === 'approved' && <h4 className="pt-1 font-14 mb-n1 color-green-dark">{funding.status}</h4>}
                    {funding.status === 'completed' && <h4 className="pt-1 font-14 mb-n1 color-theme">{funding.status}</h4>}
                    {funding.status === 'declined' && <h4 className="pt-1 font-14 mb-n1 color-red-dark">{funding.status}</h4>}
                    <p className="mb-0 font-11"> {getDate(funding.created_at)}</p>
                    </div>
                </a>
                <div className="row">
                    <strong className="col-5 color-theme">funding Amount</strong>
                    <strong className="col-7 text-end">{getAmount(funding.amount)}</strong>
                    <div className="col-12 mt-2 mb-2"><div className="divider my-0"></div></div>

                    <strong className="col-5 color-theme">funding Date </strong>
                    <strong className="col-7 text-end">{getDate(funding.created_at)}</strong>
                    <div className="col-12 mt-2 mb-2"><div className="divider my-0"></div></div>

                    <strong className="col-5 color-theme">User Email</strong>
                    <strong className="col-7 text-end">{funding.user.email}</strong>
                    <div className="col-12 mt-2 mb-2"><div className="divider my-0"></div></div> 

                    <strong className="col-5 color-theme">Payment Method</strong>
                    <strong className="col-7 text-end color-highlight p-4">{funding.payment_method}</strong>
                    <div className="col-12 mt-2 mb-2"><div className="divider my-0"></div></div>
                      
                    <strong className="col-5 color-theme">Payment Proof</strong>
                    <div className="col-12 text-center">
                        {funding.image !== null &&
                        <img className='img-fluid' src={funding.image} alt='payment proof' />
                        }
                    </div>
                    <div className="col-12 mt-2 mb-4"><div className="divider my-0"></div></div>


                    {(funding.status === 'pending' || funding.status === 'waiting approval' )&&
                    <Fragment>
                        <div className="col-6">
                            <div onClick={approvefunding} className="btn btn-s btn-full gradient-green shadow-bg shadow-bg-xs">
                            {isApprovingfunding ? <span>Approving...</span>: <span>Approve</span>} 
                            </div>
                        </div>
                        <div className="col-6">
                            <div onClick={declinefunding} className="btn btn-s btn-full gradient-red shadow-bg shadow-bg-xs">
                                {isDceliningfunding ? <span>Declining...</span>: <span>Decline</span>} 
                            </div>
                        </div>
                    </Fragment>                    
                    }
                </div>
            </div>
                }
            </div>
        </div>
    </div>
  )
}

export default ManageFunding